export const isPreOrderActive = () => {
  return process.env.VUE_APP_PRE_ORDER_ACTIVE === 'true'
}
